module.exports = ".bolt-table-status-icon-large.bolt-header-icon.l {\r\n    margin-top: 4px;\r\n}\r\n"